export default __webpack_public_path__ + "static/media/lixeiraMenuNovo.2e9a6b8f.svg";